module.exports = __webpack_public_path__ + "static/img/square.317f6c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/square.png
// module id = nExZ
// module chunks = 0